const Constants = {
  QA: {
    countryCode: "QA",
    arlocaleCode: "ar-QA",
    enlocaleCode: "en-QA",
    mobileNoLength: 8,
    webOrderNoLength: 7,
    cncWebOrderNumberLength:
      process.env.REACT_APP_CNC_WEB_ORDER_NUMBER_LENGTH_QA,
    cncHttpAuthToken: process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_QA,
    giftWalletHttpAuthToken:
      process.env.REACT_APP_GIFT_WALLET_HTTP_AUTH_TOKEN_QA,
    trackOrderAuthToken: process.env.REACT_APP_TRACK_ORDER_NUMBER_AUTH_TOKEN_QA,
    uiConfigAuthToken: process.env.REACT_APP_UI_CONFIG_AUTH_TOKEN_QA,
    getKioskHomeAssets: `items/qa_kiosk_assets/1?status=published&fields=family_offer_card_bg_en.data.full_url.*,family_offer_card_bg_ar.data.full_url.*, family_offer_card_default_bg_en.data.full_url.*, family_offer_card_default_bg_ar.data.full_url.*,family_offer_barcode_img.data.full_url.*, member_benefit_card_bg_en.data.full_url.*, member_benefit_card_bg_ar.data.full_url.*, member_benefit_card_sm_bg_en.data.full_url.*,member_benefit_card_sm_bg_ar.data.full_url.*, special_offer_card_bg_en.data.full_url.*, special_offer_card_bg_ar.data.full_url.*, special_offer_barcode_img.data.full_url.*, register_card_barcode_img.data.full_url.*`,
    preferredStoreLocations: [
      {
        id: "1",
        name: "IKEA Store Qatar",
        counterNo: 10,
      },
    ],
  },
  OM: {
    countryCode: "OM",
    arlocaleCode: "ar-OM",
    enlocaleCode: "en-OM",
    mobileNoLength: 8,
    webOrderNoLength: 7,
    cncWebOrderNumberLength:
      process.env.REACT_APP_CNC_WEB_ORDER_NUMBER_LENGTH_OM,
    cncHttpAuthToken: process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_OM,
    giftWalletHttpAuthToken:
      process.env.REACT_APP_GIFT_WALLET_HTTP_AUTH_TOKEN_OM,
    trackOrderAuthToken: process.env.REACT_APP_TRACK_ORDER_NUMBER_AUTH_TOKEN_OM,
    uiConfigAuthToken: process.env.REACT_APP_UI_CONFIG_AUTH_TOKEN_OM,
    getKioskHomeAssets: `items/om_kiosk_assets/1?status=published&fields=family_offer_card_bg_en.data.full_url.*,family_offer_card_bg_ar.data.full_url.*, family_offer_card_default_bg_en.data.full_url.*, family_offer_card_default_bg_ar.data.full_url.*,family_offer_barcode_img.data.full_url.*, member_benefit_card_bg_en.data.full_url.*, member_benefit_card_bg_ar.data.full_url.*, member_benefit_card_sm_bg_en.data.full_url.*,member_benefit_card_sm_bg_ar.data.full_url.*, special_offer_card_bg_en.data.full_url.*, special_offer_card_bg_ar.data.full_url.*, special_offer_barcode_img.data.full_url.*, register_card_barcode_img.data.full_url.*`,
    preferredStoreLocations: [],
  },
  AE: {
    countryCode: "AE",
    arlocaleCode: "ar-AE",
    enlocaleCode: "en-AE",
    mobileNoLength: 8,
    webOrderNoLength: 8,
    cncWebOrderNumberLength:
      process.env.REACT_APP_CNC_WEB_ORDER_NUMBER_LENGTH_AE,
    cncHttpAuthToken: process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_AE,
    giftWalletHttpAuthToken:
      process.env.REACT_APP_GIFT_WALLET_HTTP_AUTH_TOKEN_AE,
    trackOrderAuthToken: process.env.REACT_APP_TRACK_ORDER_NUMBER_AUTH_TOKEN_AE,
    uiConfigAuthToken: process.env.REACT_APP_UI_CONFIG_AUTH_TOKEN_AE,
    getKioskHomeAssets: `items/ae_kiosk_assets/1?status=published&fields=family_offer_card_bg_en.data.full_url.*,family_offer_card_bg_ar.data.full_url.*, family_offer_card_default_bg_en.data.full_url.*, family_offer_card_default_bg_ar.data.full_url.*,family_offer_barcode_img.data.full_url.*, member_benefit_card_bg_en.data.full_url.*, member_benefit_card_bg_ar.data.full_url.*, member_benefit_card_sm_bg_en.data.full_url.*,member_benefit_card_sm_bg_ar.data.full_url.*, special_offer_card_bg_en.data.full_url.*, special_offer_card_bg_ar.data.full_url.*, special_offer_barcode_img.data.full_url.*, register_card_barcode_img.data.full_url.*`,
    preferredStoreLocations: [],
  },
  EG: {
    countryCode: "EG",
    arlocaleCode: "ar-EG",
    enlocaleCode: "en-EG",
    mobileNoLength: 11,
    webOrderNoLength: 7,
    cncWebOrderNumberLength:
      process.env.REACT_APP_CNC_WEB_ORDER_NUMBER_LENGTH_EG,
    cncHttpAuthToken: process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_EG,
    giftWalletHttpAuthToken:
      process.env.REACT_APP_GIFT_WALLET_HTTP_AUTH_TOKEN_EG,
    trackOrderAuthToken: process.env.REACT_APP_TRACK_ORDER_NUMBER_AUTH_TOKEN_EG,
    uiConfigAuthToken: process.env.REACT_APP_UI_CONFIG_AUTH_TOKEN_EG,
    getKioskHomeAssets: `items/eg_kiosk_assets/1?status=published&fields=family_offer_card_bg_en.data.full_url.*,family_offer_card_bg_ar.data.full_url.*, family_offer_card_default_bg_en.data.full_url.*, family_offer_card_default_bg_ar.data.full_url.*,family_offer_barcode_img.data.full_url.*, member_benefit_card_bg_en.data.full_url.*, member_benefit_card_bg_ar.data.full_url.*, member_benefit_card_sm_bg_en.data.full_url.*,member_benefit_card_sm_bg_ar.data.full_url.*, special_offer_card_bg_en.data.full_url.*, special_offer_card_bg_ar.data.full_url.*, special_offer_barcode_img.data.full_url.*, register_card_barcode_img.data.full_url.*`,
    preferredStoreLocations: [],
  },
  dateDisplayFormat: "DD/MM/YYYY",
  dateFormatForApi: "YYYY-MM-DD",
  API_DATE_TIME_FORMAT: "YYYY-MM-DDTHH:mm:ssZ",
  modeType: {
    kiosk: "kiosk",
    web: "web",
  },
  menuItemType: {
    CheckGiftCardBalance: "Check Gift Card Balance",
    TrackYourOrder: "Track Your Order",
    ClickAndCollectOrder: "Click and Collect Order",
    VoiceableService: "Voiceable service",
  },
  webOrderConst: {
    status: {
      ReadyForCollection: "Ready for collection",
      CustomerArrived: "Customer arrived",
      CustomerCollected: "Customer collected",
      NotFound: "Not found",
    },
  },
  scannerDeviceType: {
    network: "network",
  },
};
export default Constants;
